import gsap, { Power3, Power1, Power2 } from "gsap";
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { SplitText } from 'gsap/SplitText';
gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(SplitText);

import _Header from '../_app/cuchillo/layout/Header';
import { GetBy } from "../_app/cuchillo/core/Element";
import { Metrics } from "../_app/cuchillo/core/Metrics";
import { Basics, isMobile } from "../_app/cuchillo/core/Basics";

export default class Header extends _Header {
  static pos = {
    name: 0,
    year: 0
  }

  static options = {
    show: {
      duration: .3,
      delay: 0,
      ease: Power3.easeOut
    },
    hide: {
      duration: .3,
      delay: 0,
      ease: Power3.easeIn
    }
  }

  static btn = GetBy.id('ShowPortfolio');
  static call = () => { };
  static click = () => {
    let delay = .25;
    gsap.to(this.initialTextLines, {
      y: '-100%',
      duration: .5,
      ease: Power1.easeOut,
      delay: delay
    });

    if (!isMobile) {
      delay += .25;
      gsap.to(this.iconName, {
        y: 0, duration: 2, ease: Power2.easeOut, delay,
        onComplete: () => {
          this.call();
        }
      });
    }

    for (let i = 0; i < this.labels.length; i++) {
      const label = this.labels[i];
      gsap.to(label, { y: '-110%', duration: 1, ease: Power2.easeOut, delay: delay + .1 * i });
    }

    if (!isMobile) {
      delay += .25;
      gsap.to(this.iconYear, {
        y: 0, duration: 2, ease: Power2.easeOut, delay
      });
    }
    gsap.to(this.iconYearVector, {
      y: '-120%',
      duration: 1.5,
      ease: Power1.easeOut,
      delay: delay + .5
    });

    if (isMobile) {
      const parentName = this.iconName.parentNode.parentNode;
      const { top } = parentName.getBoundingClientRect();
      gsap.to(parentName, {
        y: -top, duration: 1, ease: Power2.easeOut, delay: delay + .5,
        onComplete: () => {
          this.call();
        }
      });
    }
  }

  static init() {
    super.init();

    this.btn.addEventListener(Basics.clickEvent, () => { this.click() });

    this.logoVectors = GetBy.selector('#Overlay .icon--jd path');
    gsap.set(this.logoVectors, { drawSVG: '0%' });

    this.iconYear = GetBy.class('icon--yearportfolio', this.container)[0];
    this.iconYearVector = GetBy.selector('svg', this.iconYear)[0];
    gsap.set(this.iconYearVector, { y: '115%' });
    this.iconYear.style = '';

    this.iconName = GetBy.class('icon--name', this.container)[0];
    this.iconNameVector = GetBy.selector('svg', this.iconName)[0];
    gsap.set(this.iconNameVector, { y: '115%' });
    this.iconName.style = '';

    this.initialText = GetBy.class('initial-text', this.container)[0];

    const lines = new SplitText(this.initialText, { type: 'lines', linesClass: 'line-parent' }).lines;
    this.initialTextLines = new SplitText(lines, { type: 'lines', linesClass: 'line-child' }).lines;
    gsap.set(this.initialTextLines, { y: '100%' });

    this.labels = GetBy.selector('.layer-2 span', this.container);
    gsap.set(this.labels, { y: '-110%' });

    if (!isMobile) {
      const layer1 = this.iconName.parentNode.parentNode;
      const { top } = layer1.getBoundingClientRect();

      const { height: height3 } = this.initialText.getBoundingClientRect();
      gsap.set(this.initialText, { y: Metrics.HEIGHT / 2 - height3 / 2 - top });
      gsap.set(this.iconYear, { y: Metrics.HEIGHT / 2 - height3 / 2 - top });
      gsap.set(this.iconName, { y: Metrics.HEIGHT / 2 - height3 / 2 - top });
    }
  }

  static disable() {
    if (isMobile) return;
    gsap.to(this.logoVectors, { stroke: '#f2f2f2', duration: .3 });
  }

  static enable() {
    if (isMobile) return;
    gsap.to(this.logoVectors, { stroke: '#000000', duration: .3 });
  }

  static directShow() {
    gsap.set(this.iconNameVector, { y: 0 });

    if (!isMobile) {
      gsap.set(this.iconName, { y: 0 });
      gsap.set(this.iconYear, { y: 0 });
      gsap.set(this.logoVectors, { drawSVG: '100%' });
    }

    if (isMobile) {
      const parentName = this.iconName.parentNode.parentNode;
      const { top } = parentName.getBoundingClientRect();
      gsap.set(parentName, { y: -top });
    }
  }

  static show(__call = () => { }) {
    super.show();

    this.call = __call;

    let delay = .5;

    if (!isMobile) {
      const element0 = this.logoVectors[0];
      gsap.to(element0, {
        drawSVG: '100%',
        duration: 1.5,
        delay,
        ease: Power2.easeOut
      });
      const element1 = this.logoVectors[1];
      gsap.to(element1, {
        drawSVG: '100%',
        duration: 1,
        delay,
        ease: Power2.easeOut
      });
      const element2 = this.logoVectors[2];
      delay += .25;
      gsap.to(element2, {
        drawSVG: '100%',
        duration: 1,
        delay,
        ease: Power2.easeOut
      });
    }

    delay += .5;
    for (let i = 0; i < this.labels.length; i++) {
      const label = this.labels[i];
      gsap.to(label, { y: 0, duration: 1, ease: Power2.easeOut, delay: delay + .2 * i });
    }

    delay += .5;
    gsap.to(this.iconNameVector, { y: 0, duration: 1.25, ease: Power2.easeOut, delay });

    delay += .25;
    gsap.to(this.iconYearVector, { y: 0, duration: 1.25, ease: Power2.easeOut, delay });

    delay += .25;
    for (let i = 0; i < this.initialTextLines.length; i++) {
      const element = this.initialTextLines[i];
      gsap.to(element, { y: 0, duration: .75, ease: Power2.easeOut, delay: delay + .08 * i });
    }
  }
}
